import { render, staticRenderFns } from "./basePrivilegeManage.vue?vue&type=template&id=4e66b704&scoped=true"
import script from "./basePrivilegeManage.vue?vue&type=script&lang=js"
export * from "./basePrivilegeManage.vue?vue&type=script&lang=js"
import style0 from "./basePrivilegeManage.vue?vue&type=style&index=0&id=4e66b704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e66b704",
  null
  
)

export default component.exports